<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span> 
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: lead_status}" *ngIf="role=='community_manager'">Lead </span>
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']" [queryParams]="{customer_status: lead_logs.lead_status}" *ngIf="role=='designer'">Lead </span>
    <span *ngIf="lead_logs" class="capitalize" style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> {{lead_logs.lead_status | replaceChar}}</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark capitalize" style="vertical-align: -webkit-baseline-middle;">{{lead_logs.name}}</span>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>

<div class="row px-4">
  <div class="col-md-12 p-0 mt-4">
    <ul class="nav nav-tabs ss-nav-tabs" id="myTab" role="tablist">
      <li class="nav-item">
        <a class="nav-link ss-nav-link" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true" routerLink="/lead/{{lead_id}}/overview" [queryParams]="{lead_status: lead_status}" *ngIf="isProjectInWip()">Overview</a>
      </li>
      <li class="nav-item">
        <a class="nav-link active ss-nav-link" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true" routerLink="/lead/{{lead_id}}/activity-logs" [queryParams]="{lead_status: lead_status}">Activity Logs</a>
      </li>
      <li class="nav-item">
        <a class="nav-link ss-nav-link" id="profile-tab" data-toggle="tab" role="tab" aria-controls="profile" aria-selected="false" routerLink="/lead/{{lead_id}}/basic-info" [queryParams]="{lead_status: lead_status}">Basic Info</a>
      </li>
      <li class="nav-item">
        <a class="nav-link ss-nav-link" id="contact-tab" data-toggle="tab" role="tab" aria-controls="contact" aria-selected="false" routerLink="/lead/{{lead_id}}/detailed-info" [queryParams]="{lead_status: lead_status}">Detailed Info</a>
      </li>
      <li class="nav-item" *ngIf="isProjectInWip()">
        <a class="nav-link ss-nav-link" id="boq-tab" data-toggle="tab" role="tab" aria-controls="boq" aria-selected="false" routerLink="/lead/{{lead_id}}/boq" [queryParams]="{lead_status: lead_status}">BOQ</a>
      </li>
      <li class="nav-item" *ngIf="isProjectInWip()">
        <a class="nav-link ss-nav-link" id="ppt-tab" data-toggle="tab" role="tab" aria-controls="ppt" aria-selected="false" routerLink="/lead/{{lead_id}}/ppt" [queryParams]="{lead_status: lead_status}">PPT</a>
      </li>
      <li class="nav-item">
        <a class="nav-link ss-nav-link" id="files-tab" data-toggle="tab" role="tab" aria-controls="files" aria-selected="false" routerLink="/lead/{{lead_id}}/files" [queryParams]="{lead_status: lead_status}">Files</a>
      </li>
      <li class="nav-item">
        <a class="nav-link ss-nav-link" id="calendar-tab" data-toggle="tab" href="#calendar" role="tab" aria-controls="calendar" aria-selected="false" routerLink="/lead/{{lead_id}}/calendar" [queryParams]="{lead_status: lead_status}">Calendar</a>
      </li>
      <li class="nav-item" *ngIf="isProjectInWip()">
        <a class="nav-link ss-nav-link" id="proposal-tab" data-toggle="tab" href="#proposals" role="tab" aria-controls="proposals" aria-selected="false" routerLink="/lead/{{lead_id}}/proposals" [queryParams]="{lead_status: lead_status}">Proposals</a>
      </li>
      <li class="nav-item" *ngIf="isProjectInWip()">
          <a class="nav-link ss-nav-link "  id="proposal-tab" data-toggle="tab" href="#custom" role="tab" aria-controls="custom" aria-selected="false" routerLink="/lead/{{lead_id}}/custom-view" [queryParams]="{lead_status: lead_status}">Custom Element</a>
      </li>
      <li class="nav-item" *ngIf="isProjectInWip()">
        <a class="nav-link ss-nav-link" id="proposal-tab" data-toggle="tab" href="#proposals" role="tab" aria-controls="proposals" aria-selected="false" routerLink="/lead/{{lead_id}}/projects/{{ project_id}}/payments" >Payments</a>
      </li>

    </ul>
  </div>
  <div class="col-12 bg-white">

    <!-- <div class="row leadDetailsMainDiv">
      <div class="col-md-12 pl-4 borderBottom">
        <div class="leadDetailsDiv">
          <p class="my-2 vColor">Lead Details</p>
        </div>
      </div>
      <div class="col-md-4 my-4 pl-4">
        <p class="vColor fontSize14 mb-2">Name: <span class="text-dark">{{lead_logs.name}}</span></p>
        <p class="vColor fontSize14 mb-2">Role: <span class="text-dark">{{lead_logs.lead_type}}</span></p>
      </div>
      <div class="col-md-4 my-4">
        <p class="vColor fontSize14 mb-2">Contact: <span class="text-dark">{{lead_logs.contact}}</span></p>
        <p class="vColor fontSize14 mb-2">Status: <span class="text-dark">{{lead_logs.lead_status}}</span></p>
      </div>
      <div class="col-md-4 my-4">
        <p class="vColor fontSize14 mb-2">Date of Acquisition: <span class="text-dark">{{lead_logs.created_at | date:'dd MMMM, y , h:mm a'}}</span></p>
        <p class="vColor fontSize14 mb-2">Assigned CS Agent: <span class="text-dark">{{lead_logs.agent.name}}</span></p>
      </div>
    </div> -->
      <div class="row mt-4">
        <div class="col-md-12">
          <div class="phone pull-right">
            <i class="fa fa-phone cursor-pointer" (click)="callToLead(lead_logs.id)" style="    font-size: 1.5rem; color: #8F0020;"></i>
          </div>
          
          
        </div>
        
      </div>

    <div class="row my-4">
      <div class="col-md-6">
        <!-- <p class="vColor fontSize14 mb-2">DATE RANGE</p> -->
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-6 col-lg-7">
            <p class="vColor fontSize14 mb-2">USER</p>
            <div class="dropdown">

              <button class="dropdown-toggle dropdownButton dropdownButton1" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img src="../../assets/img/images/original/missing.png" class="img-fluid mobNone myFluit mr-2">
                <span>All (logs)</span>
              </button>

              <div class="dropdown-menu dropdownMenu py-1" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item mt-2" (click) = "filterLogs($event, 'all')">
                  <img src="../../assets/img/images/original/missing.png" class="img-fluid myFluit mr-2"> 
                  All (logs)
                </a>

                <a class="dropdown-item mt-2" *ngFor="let owner of log_owners" (click) = "filterLogs($event,owner.email)">
                  <img src="../../assets/img{{owner.image}}" class="img-fluid myFluit mr-2" onError="this.src='../../assets/img/images/original/missing.png'"> 
                  {{owner.name}}
                </a>
              </div>

            </div>
          </div>
          <div class="col-6 col-lg-5">
            <p class="vColor fontSize14 mb-2">SORT BY</p>
            <div class="dropdown">
              <button class="dropdown-toggle dropdownButton dropdownButton2" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Oldest First
              </button>
              <div class="dropdown-menu dropdownMenu py-1" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" (click)="sortlog('created_at', 'oldest')">Oldest First</a>
                <a class="dropdown-item" (click)="sortlog('created_at', 'newest')">Newest First</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-md-12">
        <!-- <h5 class="my-3 vColor1">Today <span class="vDate vColor ml-1">Thu Jun 23</span></h5> -->
        <!-- *ngFor="let log of filtered_logs" -->
        <div class="row justify-content-md-center" *ngFor = "let log of filtered_logs | sortDatewise:{property:columnlog, direction:directionlog}">
          <div class="col-md-11">
            <div class="row customRow mt-2 mb-1 card-shadow" data-toggle="collapse" attr.data-target="#{{log.custom_id}}" aria-expanded="false" aria-controls="collapseExample">
              <div class="col-1 mobNone text-center">
                <!-- <img src="../../assets/v3/img/profile.jpeg" class="img-fluid"> -->
                <img src="../../assets/img{{log.user_image}}" class="img-fluid" onError="this.src='../../assets/img/images/original/missing.png'"/>
              </div>
              <div class="col-12 col-lg-11 pl-lg-0" *ngIf="log.exotel==false">
                <p class="mb-0 mt-1 vColor1">
                  <span class="vPara capitalize" *ngIf="log.name">{{log.name}}({{log.role}}) </span>
                  <span class="vPara" *ngIf="!log.name">Someone </span>
                  <span>{{log.event}}</span>
                  <span>{{log.owner}}</span>
                  <span>on</span>
                  <span class="vPara">" {{log.date}} "</span></p>
                <span class="vDate vColor">{{log.time}}</span>
                <i class="cusDownArrow fa fa-caret-down"></i>
              </div>
              <div class="col-12 col-lg-11 pl-lg-0" *ngIf="log.exotel==true">
                <p class="mb-0 mt-1 vColor1">
                  <span class="vPara capitalize" *ngIf="log.whodunnit">{{log.whodunnit}}({{log.role}}) </span>
                  <span class="vPara" *ngIf="!log.whodunnit">Someone </span>
                  <span>called at</span>
                  <span class="vPara">"{{log.called_at | date: 'dd MMM, y '}}"</span></p>
                  <span class="vDate vColor">{{log.called_at | date:'h:mm a'}}</span>
                <i class="cusDownArrow fa fa-caret-down"></i>
              </div>

              <!-- <div class="col-11 pl-0">
                <p class="mb-0 mt-1 vColor1">
                  <span class="vPara" *ngIf="log.name">{{log.name}}({{log.role}}) </span>
                  <span class="vPara" *ngIf="!log.name">Someone </span>
                  <span>{{log.event}}</span>
                  <span>{{log.owner}}</span>
                  <span>on</span>
                  <span class="vPara">" {{log.date}} "</span></p>
                <span class="vDate vColor">{{log.time}}</span>
                <i class="cusDownArrow fa fa-caret-down"></i>
              </div> -->
            </div>

            <div class="row collapse" id="{{log.custom_id}}" *ngIf="log.exotel==false">
              <div class="col-md-12 p-0">
                <div class="card card-body">
                  <table class="table table-responsive">
                    <tbody>
                      <tr>
                        <th style="border: 0;">Field</th>
                        <th style="border: 0;">Original Value</th>
                        <th style="border: 0;">New Value</th>
                      </tr>
                      <tr *ngFor = "let object of log.object_changes">
                        <td style="border: 0;" class="vColor1 tableMob">{{object.name}}</td>
                        <td style="border: 0;" class="tableMob">{{object.initial}}</td>
                        <td style="border: 0;" class="tableMob">{{object.final}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row collapse" id="{{log.custom_id}}" *ngIf="log.exotel==true">
              <div class="col-md-12 p-0">
                <div class="card card-body">
                  <table class="table table-responsive">
                    <tbody>
                      <tr>
                        <th style="border: 0;">Status</th>
                        <th style="border: 0;">Duration</th>
                        <th style="border: 0;">Recording Url</th>
                      </tr>
                      <tr>
                        <td style="border: 0;" class="vColor1">{{log.status}}</td>
                        <td style="border: 0;">{{log.duration}}</td>
                        <td style="border: 0;">
                          <audio controls *ngIf="log.recording_url!=null && log.recording_url!='' ">
                            <source src="{{log.recording_url}}" type="audio/mpeg">
                              Your browser does not support the audio element.
                          </audio>
                          <span *ngIf="log.recording_url==null || log.recording_url=='' ">NA</span>
                      </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


  </div>
</div>





// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/activity-logs/viewlogs/viewlogs.component.html